export default __webpack_public_path__ + "static/media/bgLetter.70ad4195.png";